// src/polyfills/resizeObserver.ts
import { ResizeObserver as Polyfill } from '@juggle/resize-observer';

if (typeof window !== 'undefined' && typeof window.ResizeObserver === 'undefined') {
  window.ResizeObserver = Polyfill;
}
